import { useTranslation } from 'react-i18next';
import { Box, Stack, Typography, BoxProps } from '@mui/material';
import { FLOW_BUILDER2_PAGE_NS } from '../../i18n';

export const DropHereBox = (props: BoxProps & { isOver: boolean }) => {
  const { sx, isOver, ...boxProps } = props;
  const { t } = useTranslation(FLOW_BUILDER2_PAGE_NS);

  return (
    <Box
      {...boxProps}
      sx={[
        ({ palette, spacing, zIndex }) => ({
          height: '100%',
          border: `1px dashed ${isOver ? palette.primary.main : palette.border.main}`,
          borderRadius: spacing(0.5),
          fontWeight: 'bold',
          zIndex: zIndex.tooltip,
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <Stack
        sx={{
          width: '100%',
          height: '100%',
          position: 'relative',
          alignItems: 'center',
          justifyContent: 'center',
          px: 1,
        }}
      >
        <Typography color="text.secondary">{t('descriptions.dragAndDropComponents')}</Typography>
        {isOver && (
          <Box
            sx={({ palette, spacing }) => ({
              top: 0,
              right: 0,
              bottom: 0,
              left: 0,
              zIndex: 0,
              opacity: 0.05,
              position: 'absolute',
              borderRadius: spacing(0.75),
              backgroundColor: palette.primary.main,
            })}
          />
        )}
      </Stack>
    </Box>
  );
};
